/**
 * @module validator
 */

/**
 * validate a string is valid google analytics 4 measurement id or not.
 */
export function isGA4Id(arg: string) {
	return /^G-[0-9A-Z]{10,}$/.test(arg);
}
